/* eslint-disable react/no-unknown-property */
type ArrowProps = {
  direction: 'up' | 'down';
};

export const Arrow: import('react').FC<ArrowProps> = ({ direction }) =>
  direction === 'up' ? (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" data-testid="up-arrow">
      <path d="M15 12.5L10 7.5L5 12.5" stroke="#344054" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ) : (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" data-testid="down-arrow">
      <path d="M5 7.5L10 12.5L15 7.5" stroke="#344054" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
